import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";
import { NDrawer, NDrawerContent, NIcon } from "naive-ui";
import { CloseSharp, ArrowBackSharp } from "@vicons/material";
import { useStore } from "@/store";


export default /*#__PURE__*/_defineComponent({
  __name: 'DrawerView',
  props: {
  placement: {
    type: String,
    default: "right",
  },
},
  setup(__props, { expose: __expose }) {
  __expose();

const props = __props;



const store = useStore();

const active = computed(() => store.getters["docs/getUpdate"]);

const drawerHistoryLength = computed(
  () => store.getters["docs/getDrawerComponents"].length
);
const component = computed(() =>
  store.getters["docs/getDrawerComponents"].at(-1)
);

const goBack = (): void => {
  store.commit("docs/removeLastDrawerComponent");
};
const clearDrawer = (): void => {
  store.commit("docs/clearDrawerComponents");
  store.commit("docs/setUpdate", false);
};

const __returned__ = { props, store, active, drawerHistoryLength, component, goBack, clearDrawer, computed, get NDrawer() { return NDrawer }, get NDrawerContent() { return NDrawerContent }, get NIcon() { return NIcon }, get CloseSharp() { return CloseSharp }, get ArrowBackSharp() { return ArrowBackSharp }, get useStore() { return useStore } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})